import AWS from 'aws-sdk';

const s3 = new AWS.S3({
  credentials: {
    accessKeyId: process.env.VUE_APP_AWS_ACCESS_KEY,
    secretAccessKey: process.env.VUE_APP_AWS_SECRET_KEY,
  },
});
const Bucket = process.env.VUE_APP_AWS_BUCKET_NAME;

export default {
  requestSaveData({ state }, Key) {
    return new Promise((resolve, reject) => {
      s3.putObject({
        Bucket,
        Key,
        Body: JSON.stringify(state.logs),
      }, (err, data) => {
        if (err) reject(err);
        if (data) resolve(data);
      });
    });
  },
};
